<template>
  <div class="emb-aside-banner-v2" v-if="sidebanner2">
    <router-link
      :to="{name: 'Products', query: {category: sidebanner2.Category_ID, subcategory: sidebanner2.Sub_Category_ID}}"
    >
      <img
        class="emb-card"
        :src="sidebanner2.Image_547_x_315px"
        width="547"
        height="315"
        alt="aside-banner"
      />
    </router-link>
  </div>
</template>

<script>
export default {
  props: ["sidebanner2"],
};
</script>
